import { useState, useEffect, useMemo, useContext } from 'react';
import styles from '../Applicants/css/display-applicant.module.css';
import { useQuery } from '@tanstack/react-query';
import { FilterDropDown } from '../Applicants/Applicants'; 
import { AiOutlineSearch as SearchIcon } from 'react-icons/ai';
import { IoReload as ReloadIcon } from 'react-icons/io5';
import apiCall from '../../../utils/apiCall';
import { CircularProgress, styled } from '@mui/material';
import { AxiosError } from 'axios';
import { ExNyRoute, PrRoute, ExRoute, AcRoute, MiRoute, CoRoute } from '../../../utils/allRouteId';
import { RouteResponse } from '../../../types/index';
import { FetchAllRoutes, reOrderFetchedData } from '../../../hooks/FetchData';
import { Button, DateFilter } from '../../../ui-components';
import { NotificationContext } from '../../../providers/notification';
import { apiRequest, config } from '../../../api';
import fileDownload from 'js-file-download';

interface Applicants {
  ApplicantId: string;
  Name: string;
  Email: string;
  Phone: string;
  Academic: string;
  Academic_Score: string;
  Hr_Experience: string;
  Hr_Experience_Score: string;
  Sector: string;
  Trainings: string;
  Trainings_Score: string;
  Present_Employer: string;
  Designation: string;
  Total_Score: string;
  Year_experience: string;
  Remarks: string;
  Designation_Score: string;

}

interface DisplayApplicantsProps {
  setRouteName: React.Dispatch<React.SetStateAction<string>>;
}

const option1:any= [
    // {val:1, name:"Memembership Route",path:`${BASE_URL}`},
     {val: ExNyRoute, name:"Examination / NYSC"},
    {val:PrRoute, name:"Practitioner"},
    {val:ExRoute, name:"Executive"},
    {val: AcRoute, name:"Academic"},
    {val: MiRoute, name:"Military"},
    {val:CoRoute, name:"Corporate"}
  ]

const statusOptions = [
  { val: 1, name: "Pending Approval" },
  { val: 2, name: "Approved" }
];

const DisplayApplicant = ({ setRouteName }: DisplayApplicantsProps) => {
  const [filters, setFilters] = useState({
    routeId: Number(ExRoute),
    searchData: '',
    date: { start: "", end: "" }
  });
  const [d_loading, set_d_loading] = useState<boolean>(false);
  const { showNotification } = useContext(NotificationContext);
  const [routeNameInt, setRouteNameInt] = useState('')

  
  const formatDate = (date: string) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${year}-${month}-${day}`; // Adjusted to YYYY-MM-DD
  };

const getAllApplicants = async (): Promise<Applicants[]> => {
    let url = `/Applicant/GetAllApplicantDetailByRouteId?PageNumber=1&PageSize=100&RouteId=${filters.routeId}`;
    
    // Log the routeId and date for debugging
    console.log("Fetching applicants with:", {
        routeId: filters.routeId,
        startDate: formatDate(filters.date.start),
        endDate: formatDate(filters.date.end)
    });

    if (filters.date.start) url += `&sDate=${formatDate(filters.date.start)}`;
    if (filters.date.end) url += `&eDate=${formatDate(filters.date.end)}`;

    try {
        const response = await apiCall().get(url);
        console.log("API Response:", response.data); // Log the response data
        return response.data?.Data || [];
    } catch (error) {
        console.error("Error fetching applicants:", error); // Log the error for debugging
        throw error; // Rethrow the error to be handled by the query
    }
};


  const { isLoading, data } = FetchAllRoutes();
  const reOrderedAllRoutes = data ? reOrderFetchedData((data as RouteResponse)?.Data) : [];
  const allRoutes = isLoading ? [] : reOrderedAllRoutes.map(item => ({ name: item?.RouteName, val: item?.RouteId }));

  const getAllApplicantsQuery = useQuery([`get-All-Applicant ${filters.routeId}`, filters.searchData], getAllApplicants, { retry: 0, refetchOnWindowFocus: false });
  const getAllApplicantsData = getAllApplicantsQuery?.data;
  const getAllApplicantsError = getAllApplicantsQuery?.error as AxiosError;

  const switchRouteId = (route: { val: number, name: string }) => {
    setFilters(prev => ({ ...prev, routeId: route.val }));
    setRouteName(route.name);
  };

  const filteredData = getAllApplicantsData?.filter(x => (
    Object.values(x).join("").toLowerCase().includes(filters.searchData.toLowerCase())
  ));

  const handleDownload = () => {
    set_d_loading(true);
    apiRequest(
      `api/Applicant/DownloadAllApplicantDetailByRouteId?routeId=${filters.routeId}&sDate=${formatDate(filters.date.start)}&eDate=${formatDate(filters.date.end)}`,
      "GET",
      {},
      config,
      true
    )
      .then((data: any) => {
        if (!data?.Message) {
          fileDownload(data, `applicantfile${Math.floor(Math.random() * 10000) + 1}.xlsx`);
          showNotification({ message: 'File downloading...', type: 'success' });
        } else {
          showNotification({ message: data.Message || 'No file to download', type: 'success' });
        }
        set_d_loading(false);
      })
      .catch((error: any) => {
        console.error(error); // Log the error for debugging
        showNotification({ message: 'Sorry, file cannot be downloaded', type: 'error' });
        set_d_loading(false);
      });
  };

  return (
    <div className={styles.container}>
      <div className={styles.filterDiv}>
        <label className={styles.searchForm}>
          <span className={styles.sI}><SearchIcon /></span>
          <input type="text" placeholder='Search' value={filters.searchData} onChange={e => setFilters(prev => ({ ...prev, searchData: e.target.value }))} />
          <button className={styles.rBtn} type="submit"><ReloadIcon /></button>
        </label>
        <FilterDropDown onChange={switchRouteId} text={routeNameInt ? `${routeNameInt}` : 'Membership Route'} bg="#0A3922" color="#fff" options={allRoutes} />
        <DateFilter onChange={(date: any) => setFilters(prev => ({ ...prev, date }))} />
        <Button onClick={handleDownload} children={d_loading ? 'Loading...' : 'Download'} border="#E2E4E9" bg="#0A3922" color="#fff" />
      </div>
      <div>
        {getAllApplicantsQuery?.isFetching ? (
          <CircularProgress sx={{ fontSize: '1rem', marginInline: 'auto', display: 'block', marginBlock: '2rem' }} />
        ) : getAllApplicantsQuery.isError ? (
          <StyledError>{getAllApplicantsError?.message}</StyledError>
        ) : filteredData && filteredData.length > 0 ? (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Academic</th>
                <th>Academic Score</th>
                <th>HR Experience</th>
                <th>HR Experience Score</th>
                <th>Sector</th>
                <th>Trainings</th>
                <th>Trainings Score</th>
                <th>Present Employer</th>
                <th>Designation</th>
                <th>Designation Score</th>
                <th>Total Score</th>
                <th>Years of Experience</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {(filters.searchData.length > 0 ? filteredData : getAllApplicantsData)?.map(applicant => (
                <tr key={applicant.ApplicantId}>
                  <td>{applicant.Name || "N/A"}</td>
                  <td>{applicant.Email || "N/A"}</td>
                  <td>{applicant.Phone || "N/A"}</td>
                  <td>{applicant.Academic || "N/A"}</td>
                  <td>{applicant.Academic_Score || "0"}</td>
                  <td>{applicant.Hr_Experience || "N/A"}</td>
                  <td>{applicant.Hr_Experience_Score || "0"}</td>
                  <td>{applicant.Sector || "N/A"}</td>
                  <td>{applicant.Trainings || "N/A"}</td>
                  <td>{applicant.Trainings_Score || "0"}</td>
                  <td>{applicant.Present_Employer || "N/A"}</td>
                  <td>{applicant.Designation || "N/A"}</td>
                  <td>{applicant.Designation_Score || "0"}</td>
                  <td>{applicant.Total_Score || "0"}</td>
                  <td>{applicant.Year_experience || "N/A"}</td>
                  <td>{applicant.Remarks || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <NoResult>No Results</NoResult>
        )}
      </div>
    </div>
  );
};

export default DisplayApplicant;

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`;

const NoResult = styled('div')`
  margin-block-start: 0px;
`;
